import { Theme as MuiTheme, SxProps } from '@mui/material';

export const mergeSx = <Theme extends object = MuiTheme>(...args: (SxProps<Theme> | undefined)[]): SxProps<Theme> =>
    args
        .filter(Boolean)
        .map((sx) => (Array.isArray(sx) ? sx : [sx]))
        .flat() as SxProps<Theme>;
